module.exports = __webpack_public_path__ + "img/79be813.jpg";